import { PDFDocument } from 'pdf-lib';
import { ENDPOINT } from 'constants/variables';

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

export const fetchFormDIDecaQr = async (formdiId, token) => {
  if (!formdiId) return '';
  try {
    const response = await fetch(
      `${ENDPOINT}/deca/documents/formdi/${formdiId}/qr`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (response.status === 204) return '';
    if (!response.ok) return '';
    return blobToDataUrl(await response.blob());
  } catch {
    return '';
  }
};

export const addFormDIDecaQrToPdf = async (pdfBlob, qrDataUrl) => {
  if (!pdfBlob || !qrDataUrl) return pdfBlob;
  const pdf = await PDFDocument.load(await pdfBlob.arrayBuffer());
  const qr = await pdf.embedPng(qrDataUrl);
  const firstPage = pdf.getPages()[0];
  const size = 54;
  firstPage.drawImage(qr, {
    x: firstPage.getWidth() - 95,
    y: firstPage.getHeight() - 66,
    width: size,
    height: size,
  });
  return new Blob([await pdf.save()], { type: 'application/pdf' });
};
